import React, { useState } from 'react';
import { WorkflowState } from '../../../models/enums/WorkflowState';
import WorkflowStateBadge from '../../common/WorkflowStateBadge';
import './ProgressBarSmall.css';

interface ProgressBarSmallProps {
	workflowState: WorkflowState;
}

const ProgressBarSmall = ({ workflowState }: ProgressBarSmallProps) => {
	const [showTooltip, setShowTooltip] = useState(false);

	const getFirstBulletClass = () => {
		switch (workflowState.value) {
			case WorkflowState.Review.value:
			case WorkflowState.Draft.value:
				return 'circle-yellow';
			case WorkflowState.PendingForDOAGApproval.value:
				return '';
			case WorkflowState.Cancelled.value:
			case WorkflowState.Rejected.value:	
				return 'circle-red';
			default:
				return 'back-blue';
		}
	};

	const getSecondBulletClass = () => {
		switch (workflowState.value) {
			case WorkflowState.Review.value:
			case WorkflowState.Draft.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.Cancelled.value:
			case WorkflowState.Rejected.value:
				return '';
			case WorkflowState.PendingForPolicyTeamApproval.value:
				return 'circle-yellow';
			default:
				return 'back-blue';
		}
	};

	const getThirdBulletClass = () => {
		switch (workflowState.value) {
			case WorkflowState.Review.value:
			case WorkflowState.Draft.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.PendingForPolicyTeamApproval.value:
			case WorkflowState.Cancelled.value:
			case WorkflowState.Rejected.value:
				return '';
			case WorkflowState.PendingSolutionArchitectureApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.PendingOTCRMApproval.value:
				return 'circle-yellow';
			default:
				return 'back-blue';
		}
	};

	const getLastBulletClass = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
				return 'circle-yellow';
			case WorkflowState.Error.value:
			case WorkflowState.ImplementationFailed.value:
				return 'circle-red';
			case WorkflowState.Completed.value:
				return 'circle-green';
			default:
				return '';
		}
	};

	return (
		<div
			className="progress"
			onMouseEnter={() => setShowTooltip(true)}
			onMouseLeave={() => setShowTooltip(false)}
			title=""
		>
			{showTooltip && (
				<div className="tooltip">
					<WorkflowStateBadge fullWidth workflowState={workflowState} />
				</div>
			)}
			<div className="progress-bar-line" />
			<div className={`circle ${getFirstBulletClass()} left-0`} />
			<div className={`circle ${getSecondBulletClass()} left-33`} />
			<div className={`circle ${getThirdBulletClass()} left-66`} />
			<div className={`circle ${getLastBulletClass()} left-100`} />
		</div>
	);
};

export default ProgressBarSmall;
